import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createLogoEntry = createAsyncThunk('createLogoEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertLogo`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateLogoEntry = createAsyncThunk('updateLogoEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateLogo`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchLogoData = createAsyncThunk('fetchLogoData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getLogolist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleLogo = createAsyncThunk('fetchSingleLogo', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getLogolist&logoId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleLogo = createAsyncThunk('deleteSingleLogo', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteLogo&logoId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const logoSlice = createSlice({
    name: 'LogoData',
    initialState: {
        isLoading: false,
        logo: null,
        deleteLogo: null,
        singleLogo: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLogoData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchLogoData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.logo = action.payload;
        });
        builder.addCase(fetchLogoData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleLogo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleLogo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteLogo = action.payload;
        });
        builder.addCase(deleteSingleLogo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleLogo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleLogo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleLogo = action.payload;
        });
        builder.addCase(fetchSingleLogo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default logoSlice.reducer;
